import L from "leaflet"
export const mapBounds = L.latLngBounds(
  L.latLng(4, 100.14),   // Góc tây nam Việt Nam
  L.latLng(23.39, 120.46)   // Góc đông bắc Việt Nam
);
export const rankZoom = {
  1: { minZoom: 1, maxZoom: 4 },
  2: { minZoom: 5, maxZoom: 11 },
  3: { minZoom: 7, maxZoom: 14 },
  "track-point": { minZoom: 10 ,maxZoom: 30},
  "port": { minZoom: 7, maxZoom: 30  },
};
export const stylesDict = {
  none: { fill: false, stroke: false, opacity: 0, fillOpacity: 0 },
  //maptiler
  water: {
    fill: true,
    weight: 0,
    fillColor: "#a0c8f0",
    fillOpacity: 0.7
  },
  waterway: {
    color: "#a0c8f0",
    weight: 1
  },
  landcover: {
    fill: true,
    weight: 0,
    fillColor: "#e0e0d0",
    fillOpacity: 0.6
  },
  landuse: {
    fill: true,
    weight: 0,
    fillColor: "#dfd2ae",
    fillOpacity: 0.6
  },
  mountain_peak: {
    fill: true,
    radius: 3,
    fillColor: "#888888",
    fillOpacity: 1,
    color: "#000000",
    weight: 1
  },
  park: {
    fill: true,
    weight: 0,
    fillColor: "#c5e1a5",
    fillOpacity: 0.6
  },
  boundary: function (properties: any, zoom: number) {
    if (properties.admin_level == 2) {
      return {
        color: '#0000ff',
        weight: 0.5,
        dashArray: '5,5',
        lineCap: 'round',
        lineJoin: 'round',
        opacity: 0.9
      }
    } else {
      return stylesDict.none;
    }
  },
  aeroway: {
    color: "#eeeeee",
    weight: 1,
    fillColor: "#eeeeee",
    fillOpacity: 0.6
  },
  transportation: {
    color: "#808080",
    weight: 1
  },
  building: {
    fill: true,
    weight: 0,
    fillColor: "#d1cfcf",
    fillOpacity: 0.7
  },
  water_name: {
    color: "#0050c0",
    weight: 0,
    fill: false
  },
  transportation_name: {
    color: "#333333",
    weight: 0,
    fill: false
  },
  place: {
    radius: 4,
    fillColor: "#ff5722",
    color: "#000000",
    weight: 1,
    fillOpacity: 0.9
  },
  housenumber: {
    color: "#000000",
    weight: 0,
    fill: false
  },
  poi: {
    radius: 4,
    fillColor: "#4caf50",
    color: "#000000",
    weight: 1,
    fillOpacity: 0.8
  },
  aerodrome_label: {
    color: "#3f51b5",
    weight: 0,
    fill: false
  },
  //mapbox
  admin: function (properties: any, zoom: number) {
    if (properties.admin_level == 0) {
      return {
        color: '#0000ff',
        weight: 1.5,
        dashArray: '5,5',
        lineCap: 'round',
        lineJoin: 'round',
        opacity: 0.9
      }
    } else {
      return stylesDict.none;
    }
  },
  airport_label: () => { return stylesDict.aerodrome_label },
  housenum_label: () => { return stylesDict.housenumber },
  landuse_overlay: () => { return stylesDict.landcover },
  motorway_junction: () => { return stylesDict.transportation },
  natural_label: () => { return stylesDict.park },
  place_label: () => { return stylesDict.place },
  poi_label: () => { return stylesDict.poi },
  road: () => { return stylesDict.transportation },
  structure: {
    fill: true,
    weight: 0,
    fillColor: "#eabebeff",
    fillOpacity: 0.7
  },
  transit_stop_label: () => { return stylesDict.poi },
  //TomTom
  land_cover: () => stylesDict.landcover,
  land_use: () => stylesDict.landuse,
  structures: () => stylesDict.structure,
  structures_lines: () => stylesDict.structure,
  overlays: () => stylesDict.park,
  built_up_areas: {
    fill: true,
    weight: 0,
    fillColor: "#f76ee2ff",
    fillOpacity: 0.7
  },
  transit_areas: () => stylesDict.transportation,
  buildings: () => stylesDict.building,
  earth_cover: {
    fill: true,
    weight: 0,
    fillColor: "#cdf52bff",
    fillOpacity: 0.7
  },
  places: () => stylesDict.place,
  carto_labels: () => stylesDict.transportation,
  transit: () => stylesDict.transportation,
  roads: () => stylesDict.transportation,
  roads_areas: () => stylesDict.transportation,
  roads_points: () => stylesDict.transportation,
  boundaries: function (properties: any, zoom: number) {
    if (properties.category == "country") {
      return {
        color: '#0000ff',
        weight: 1.5,
        dashArray: '5,5',
        lineCap: 'round',
        lineJoin: 'round',
        opacity: 0.9
      }
    } else {
      return stylesDict.none;
    }
  },
  water_lines: () => stylesDict.waterway,
};
export const tileLayerStyles = {
  //maptiler
  water: {
    fill: true,
    weight: 0,
    fillColor: "#a0c8f0",
    fillOpacity: 0.7
  },
  waterway: {
    color: "#a0c8f0",
    weight: 1
  },
  landcover: {
    fill: true,
    weight: 0,
    fillColor: "#e0e0d0",
    fillOpacity: 0.6
  },
  landuse: {
    fill: true,
    weight: 0,
    fillColor: "#dfd2ae",
    fillOpacity: 0.6
  },
  mountain_peak: stylesDict.none,
  park: {
    fill: true,
    weight: 0,
    fillColor: "#c5e1a5",
    fillOpacity: 0.6
  },
  boundary: function (properties: any, zoom: number) {
    if (properties.admin_level == 2) {
      return {
        color: '#0000ff',
        weight: 0.5,
        dashArray: '5,5',
        lineCap: 'round',
        lineJoin: 'round',
        opacity: 0.9
      }
    } else {
      return stylesDict.none;
    }
  },
  aeroway: stylesDict.none,
  transportation: stylesDict.none,
  building: {
    fill: true,
    weight: 0,
    fillColor: "#d1cfcf",
    fillOpacity: 0.7
  },
  water_name: {
    color: "#0050c0",
    weight: 0,
    fill: false
  },
  transportation_name: stylesDict.none,
  place: stylesDict.none,
  housenumber: {
    color: "#000000",
    weight: 0,
    fill: false
  },
  poi: stylesDict.none,
  aerodrome_label: stylesDict.none,
  //mapbox
  admin: function (properties: any, zoom: number) {
    if (properties.iso_3166_1.includes("VN-") || properties.iso_3166_1.includes("-VN")) {
      return {
        color: '#0000ff',
        weight: 1.5,
        dashArray: '5,5',
        lineCap: 'round',
        lineJoin: 'round',
        opacity: 0.9
      }
    } else {
      return stylesDict.none;
    }
  },
  airport_label: () => { return stylesDict.none },
  housenum_label: () => { return stylesDict.none },
  landuse_overlay: () => { return stylesDict.landcover },
  motorway_junction: () => { return stylesDict.none },
  natural_label: () => { return stylesDict.none },
  place_label: () => { return stylesDict.none },
  poi_label: () => { return stylesDict.none },
  road: () => { return stylesDict.none },
  structure: {
    fill: true,
    weight: 0,
    fillColor: "#eabebeff",
    fillOpacity: 0.7
  },
  transit_stop_label: () => { return stylesDict.none },
  //TomTom
  land_cover: () => stylesDict.landcover,
  land_use: () => stylesDict.landuse,
  structures: () => stylesDict.structure,
  structures_lines: () => stylesDict.structure,
  overlays: () => stylesDict.park,
  built_up_areas: {
    fill: true,
    weight: 0,
    fillColor: "#f76ee2ff",
    fillOpacity: 0.1,
  },
  transit_areas: () => stylesDict.none,
  buildings: () => stylesDict.building,
  earth_cover: {
    fill: true,
    weight: 0,
    fillColor: "#d0f34533",
    fillOpacity: 0.7
  },
  places: () => stylesDict.none,
  carto_labels: () => stylesDict.none,
  transit: () => stylesDict.none,
  roads_areas: () => stylesDict.none,
  roads_points: () => stylesDict.none,
  roads: () => stylesDict.none,
  boundaries: function (properties: any, zoom: number) {
    if (properties.category == "country") {
      return {
        color: '#0000ff',
        weight: 1.5,
        dashArray: '5,5',
        lineCap: 'round',
        lineJoin: 'round',
        opacity: 0.9
      }
    } else {
      return stylesDict.none;
    }
  },
  water_lines: () => stylesDict.waterway,
  default: stylesDict.none,
};
export const borders = [{
  color: "#1e00ff",
  points: [[21.20972, 108.20861], [20.71889, 107.45611], [20.61444, 107.20694], [19.3475, 105.93389], [18.79278, 105.99639], [17.91389, 106.6725], [17.16083, 107.34306], [15.37778, 109.13972], [12.655, 109.56944], [11.14972, 109.15722], [10.01056, 106.97889], [9.3575, 106.67194], [8.97417, 105.74806], [8.41806, 105.24028], [8.40889, 104.53694], [10.0, 104.13833], [10.005, 104.13833], [10.37944, 103.8075]],
}, {
  color: "#ff0000",
  points: [[21.20972, 108.20861], [20.80333, 108.29444], [20.0, 107.12806], [19.55194, 106.62139], [18.66667, 106.62139], [18.31611, 106.88556], [18.0, 107.03194], [17.39389, 107.57778], [15.62111, 109.62444], [12.61444, 110.08972], [10.77667, 109.57639], [9.60361, 107.35167], [8.96861, 107.04694], [8.55333, 106.04639], [7.91833, 105.46611], [7.89889, 104.03306], [9.49917, 104.03056], [9.5, 103.69444], [9.99333, 103.42444], [10.37944, 103.8075]]
}];